module.exports = __webpack_public_path__ + "static/media/download-icon-blue-bg.c568edbe.png";